import { Tolgee, DevTools, FormatSimple } from '@tolgee/react';
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

export const tolgee = Tolgee().use(DevTools()).use(FormatSimple()).init({
    language: 'en',
    apiUrl: process.env.REACT_APP_TOLGEE_API_URL,
    apiKey: process.env.REACT_APP_TOLGEE_API_KEY,
    staticData: {
        en,
        es,
        pt
    }
});
